//총학생회 활동 상단 배너
import { NavLink, useLocation } from "react-router-dom";
import "./Tab.css";

export default function Tab() {
    const location = useLocation();
    const tabs = [
        {path: "/stdcouncil-log/Notice", name: "공지사항"},
        {path: "/stdcouncil-log/Event", name: "행사"},
        {path: "/stdcouncil-log/Partnership", name: "제휴•협력"},
        {path: "/stdcouncil-log/Calendar", name: "달력"},
    ];
    return (
            <div className="stdlog-chart">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        className={({ isActive }) => {
                            if (tab.path === "/stdcouncil-log/Notice") {
                                return isActive || location.pathname === "/stdcouncil-log" ? "chart active" : "chart";
                            }
                            return isActive ? "chart active" : "chart";
                        }}
                    >
                        {tab.name}
                    </NavLink>
                ))}
            </div>
    );
}